import React from 'react';

function Conditions() {
    return (
        <div className="Conditions">
            <div className="card shadows logo">
                <img src="../assets/img/logo.png" className="card-img-top p-3 pb-0" alt="Logo" />
                <div className="card-body pt-0">
                    <h4 className="card-title text-center">เงื่อนไขการให้บริการ</h4>
                    <p className="card-text text-center">
                        1.จอดฟรี 4 ชั่วโมง เกินจากนั้นคิดชั่วโมงละ 40 บาท<br />
                        2.บัตรนี้ไม่ถือเป็นการรับฝากรถยนต์ <br />
                        บริษัทจะไม่รับผิดชอบในความเสียหาย หรือ<br /> 
                        อุบัติเหตุใดๆ ที่เกิดแก่รถยนต์ <br />
                        รวมทั้งการสูญหายของทรัพย์สินที่อยู่ภายในรถทุกกรณี<br />
                        3.ขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไข<br />
                        โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
                    </p>
                    <p className="text-center" style={{ fontSize: 'large' }}>*** บัตรหายปรับ 300 บาท ***</p>
                    <p className="text-center" style={{ fontSize: 'small' }}>เศษของชั่วโมงคิดเป็นเต็มชั่วโมง</p>
                </div>
            </div>

            <div style={{ width: '100%' }}>
                <p className="text-center">Version 1.0.0</p>
                <p className="text-center">© 2023 AccessLink Innovation Co., Ltd.</p>
            </div>
        </div>
    );
}

export default Conditions;
